"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _compact2 = _interopRequireDefault(require("lodash/compact"));

var _castArray2 = _interopRequireDefault(require("lodash/castArray"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function triggerOnKeys(fn, keyCodes) {
  var codes = (0, _compact2["default"])((0, _castArray2["default"])(keyCodes));
  return function (e) {
    var key = e.which || e.keyCode;
    if (!codes.some(function (keyCode) {
      return keyCode == key;
    })) return;
    return fn(e);
  };
}

var _default = triggerOnKeys;
exports["default"] = _default;